import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Directive({
  standalone: true
})
export class WindowUnloadDirective {
 
  urlsToExclude = ['/order/', '/user/']
  
  constructor(private router: Router) { }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event) {
    if (this.urlsToExclude.some(url => this.router.url.startsWith(url)) && environment.sourceName !== 'SARAPLUS Local'){
      event.preventDefault();
      return false
    }
    return true
  }

  @HostListener('window:unload', ['$event'])
  onUnload(event: Event) {
    if (this.urlsToExclude.some(url => this.router.url.startsWith(url)) && environment.sourceName !== 'SARAPLUS Local'){
      event.preventDefault();
      return false
    }
    return true
  }
}
